module.exports = __webpack_public_path__ + "static/4_KING-21dd1851132aab4e17f27fd6ee3e3691.png";